<template>
	<footer
		class="relative flex-shrink-0 px-5 py-4 mt-auto text-center text-white bg-neutral-900 rainbow-border-top"
		:class="{ 'pb-[160px]': showBannerSpacer }"
	>
		<div
			class="flex flex-col items-center justify-center pt-2 pb-3 gap-x-16 gap-y-5 lg:flex-row lg:py-2"
		>
			<!-- Copyrights -->
			<div class="shrink-0">
				&copy; {{ new Date().getFullYear() }} {{ $t('app.title') }}
			</div>

			<!-- Links -->
			<div class="flex flex-wrap justify-center gap-x-6">
				<!-- Imprint -->
				<NuxtLink
					to="/impressum"
					class="text-white transition-colors underline-offset-4 hover:text-neutral-300 hover:underline"
				>
					{{ $t('footer.help.label') }}
				</NuxtLink>

				<!-- Data protection -->
				<NuxtLink
					to="/privacy"
					class="text-white transition-colors underline-offset-4 hover:text-neutral-300 hover:underline"
				>
					{{ $t('footer.privacy.label') }}
				</NuxtLink>

				<!-- GTC -->
				<NuxtLink
					to="/terms"
					class="text-white transition-colors underline-offset-4 hover:text-neutral-300 hover:underline"
				>
					{{ $t('footer.terms.label') }}
				</NuxtLink>
			</div>

			<!-- Support -->
			<div class="flex gap-x-4">
				<a
					:href="helpCenterUrl"
					:title="$t('footer.help-center.label')"
					target="_blank"
					rel="noopener noreferrer"
					class="flex items-center gap-2 text-white transition-colors underline-offset-4 hover:text-neutral-300 hover:underline"
				>
					<IconInfoCircle />
					<span>
						{{ $t('footer.help-center.label') }}
					</span>
				</a>

				<!-- Language selector -->
				<template v-if="showLanguageSelector">
					<div class="w-px bg-neutral-600" />

					<LanguageSwitcher />
				</template>
			</div>
		</div>
	</footer>
</template>

<script>
import LanguageSwitcher from './language-switcher'
import { IconInfoCircle } from '~/components/Icons'

const HELP_CENTER_URL = 'https://help.apropos.jobs'

export default {
	components: {
		LanguageSwitcher,
		IconInfoCircle
	},
	props: {
		reserveCookieBannerSpace: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			helpCenterUrl: HELP_CENTER_URL
		}
	},
	computed: {
		showLanguageSelector() {
			const routePath = this.$route?.path || ''

			return (
				routePath.includes('/assessment/applicant/') || !this.$user
			)
		},
		showBannerSpacer() {
			if (!this.reserveCookieBannerSpace || !this.$cookieConsent) {
				return false
			}

			return !this.$cookieConsent.hasAnswered()
		}
	}
}
</script>
